<template>
  <div id="app">
    <router-view />
    
    <!-- Composants globaux -->
    <Toast v-if="showToast" />
    <ModalContainer v-if="showModal" />
    
    <!-- ✅ Bannière de cookies -->
    <CookieBanner 
      v-model:visible="showCookieBanner"
      @accept="onCookieAccept"
      @refuse="onCookieRefuse"
      @save="onCookieSave"
    />
    <!-- 🔥 Supprime le bouton de test ici -->
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue';
import Toast from '@/components/common/Toast.vue';
import ModalContainer from '@/components/common/ModalContainer.vue';
import CookieBanner from '@/components/CookieBanner.vue';
import { useCookies } from '@/composables/useCookies';

export default defineComponent({
  name: 'App',
  components: {
    Toast,
    ModalContainer,
    CookieBanner
  },
  data() {
    return {
      showToast: false,
      showModal: false
    };
  },
  setup() {
    const { showBanner, init } = useCookies();
    const showCookieBanner = ref(false);

    const onCookieAccept = () => {
      console.log('✅ Cookies acceptés');
    };

    const onCookieRefuse = () => {
      console.log('❌ Cookies refusés');
    };

    const onCookieSave = (preferences: any) => {
      console.log('💾 Préférences sauvegardées:', preferences);
    };

    onMounted(() => {
      init();
      showCookieBanner.value = showBanner.value;
    });

    watch(showBanner, (newVal) => {
      showCookieBanner.value = newVal;
    });

    return {
      showCookieBanner,
      onCookieAccept,
      onCookieRefuse,
      onCookieSave
    };
  }
});
</script>

<style lang="scss">
@use '@/styles/main';
@use '@/styles/variables';

#app {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>